import CitySEOHead from "@/components/feature/CitySEOHead";
import WYSHeroSection from "./components/HeroSection";
import WYSCitiesDirectory from "./components/CitiesDirectory";
import WYSStateResources from "./components/StateResources";
import WYSFAQSection, { faqs } from "./components/FAQSection";
import WYSFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function WyomingStatePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Wyoming"
        state="Wyoming"
        stateAbbr="WY"
        route="/wyoming-state/"
        title="Wyoming Passport Services — Expedited & Emergency | Fast Passport Center"
        description="Expedited passport services across Wyoming — Cheyenne, Casper, Jackson, Laramie, Gillette, and Rock Springs. Emergency processing as fast as 24 hours. A+ BBB rated courier service."
        geoPlacename="Wyoming, United States"
        geoPosition="43.0759678;-107.2902839"
        faqs={faqs.map(f => ({ q: f.question, a: f.answer }))}
        servicesSchema={servicesList}
      />
      <WYSHeroSection />
      <WYSCitiesDirectory />
      <WYSStateResources />
      <WYSFAQSection />
      <SEOCrossLinks state="WY" />
      <WYSFinalCTA />
    </div>
  );
}